<template>
  <div class="relative h-14 bg-primary text-white">
    <div
      class="font-medium line-clamp-1 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    >
      <h1>{{ title }}</h1>
    </div>

    <div class="flex items-center justify-between h-full">
      <div class="w-14 flex-none h-full">
        <button type="button" aria-label="返回上一頁" class="w-full h-full" @click="skipPage" v-if="backable">
          <ChevronLeftIcon class="m-auto" />
        </button>
      </div>

      <div class="flex-none flex items-center">
        <select
          class="field border-none bg-inherit text-white pr-8"
          aria-label="選擇語言與地區"
          @change="changeLocal"
          v-if="locales.length && localable && !isAlipayHK"
        >
          <option
            v-for="i in locales"
            :value="i.code"
            :key="i.code"
            :selected="$i18n.locale == i.code"
            v-text="i.name"
          />
        </select>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon } from "@vue-hero-icons/outline";
import { mapGetters } from "vuex";

export default {
  components: {
    ChevronLeftIcon,
  },
  props: {
    title: [String, Number],
    backable: Boolean,
    back: {
      type: Function,
    },
    product: {
      type: Object,
    },
    localable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    skipPage() {
      if (!this.product) {
        this.back();
      } else {
        this.$router.push(
          this.localePath(
            `/order?category=${this.product.category_id}&type=${this.product.type}`
          )
        );
      }
    },
    async changeLocal(el) {
      const fromLocale = this.$i18n.locale;
      const locale = el.target.value;
      if (this.$track && fromLocale !== locale) {
        this.$track.event("region_change", {
          from_region: fromLocale,
          to_region: locale,
        });
      }
      this.$i18n.setLocale(locale);
      this.$cookies.set("loc", locale);

      // get current path
      const path = this.$route.path;

      window.location.href = this.localePath(path);
    },
  },
  computed: {
    ...mapGetters({
      locales: "app/locales",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
